import React from "react"
import { Box, Link, Heading } from "theme-ui"
import { format } from "date-fns"

const ArticleListing = ({
  fields: { slug },
  frontmatter: { title, description, published },
}) => {
  if (!title && !description && !published) {
    return null
  }

  let href = slug.startsWith("/") ? slug : `/${slug}`
  if (!href.endsWith("/")) {
    href += "/"
  }

  return (
    <Box sx={{ mb: 4 }}>
      <Link href={href}>
        <Heading>{title}</Heading>
      </Link>

      <p>
        {description}
        <br />
        <small>
          <em>{format(new Date(published), "MMMM do, yyyy")}</em>
        </small>
      </p>
    </Box>
  )
}

export default ArticleListing
